import {
    Button,
    EditIcon,
    Flex,
    Skeleton,
    Text,
} from "@fluentui/react-northstar";
import styled from "styled-components";
import { DocumentColor } from "@fluentui/react-icons";
import { ProgressBar } from "@fluentui/react-components";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants/routes";
import moment from "moment";
import DialogExportFactsheet from "../../../pages/New_Onboarding/components/TableFactsheet/DialogExportFactsheet";

const CardProgressFactsheet = ({
    isLoading = false,
    completeness_percentage = 0,
    completeness_due_date = null,
    completeness_status_id = null,
    id_user = null,
    fromPage = "preonboarding",
}) => {
    const navigate = useNavigate();

    const formatedDueDate = completeness_due_date
        ? moment(completeness_due_date).format("D MMM YYYY")
        : "--";

    const isIncomplete =
        completeness_status_id === 0 || completeness_status_id === 3;

    return (
        <SFlexEnrollementForm column>
            <SFlexTop vAlign="center">
                <SFlexTopIcon>
                    <DocumentColor />
                </SFlexTopIcon>
                <STextTitle content="Votre fiche employé" />
            </SFlexTop>
            <SFlexBody>
                <STextDescription content="Renseignez vos informations personnelles, vos coordonnées bancaires et vos données de contact d'urgence. Une fois complétée, votre fiche sera transmise à votre responsable RH pour validation." />
            </SFlexBody>
            <SFlexProgress column>
                <SFlexProgressLabel fill>
                    <STextProgress content="Complétude — champs obligatoires" />
                    {isLoading ? (
                        <Flex>
                            <Skeleton animation="pulse">
                                <Skeleton.Line width="34px" height="20px" />
                            </Skeleton>
                        </Flex>
                    ) : (
                        <STextPercent
                            content={`${completeness_percentage ?? ""} %`}
                        />
                    )}
                </SFlexProgressLabel>
                <ProgressBar
                    value={(completeness_percentage ?? 0) / 100}
                    color="success"
                    thickness="large"
                />
            </SFlexProgress>
            <SFlexFooter>
                {fromPage === "dashboard" ? (
                    isIncomplete ? (
                        <SButton
                            content="Compléter ma fiche"
                            icon={<EditIcon />}
                            onClick={() =>
                                navigate(ROUTES.collaborator_factsheet)
                            }
                        />
                    ) : (
                        <DialogExportFactsheet
                            id_user={id_user}
                            buttonContent="⬇ Télécharger ma fiche"
                        />
                    )
                ) : (
                    <SButton
                        content="Compléter ma fiche"
                        icon={<EditIcon />}
                        onClick={() => navigate(ROUTES.collaborator_factsheet)}
                    />
                )}
                <SFlexDeadline gap="gap.smaller">
                    <STextDeadline content="⏱ Échéance : " />
                    {isLoading ? (
                        <Flex>
                            <Skeleton animation="pulse">
                                <Skeleton.Line width="64px" height="32px" />
                            </Skeleton>
                        </Flex>
                    ) : (
                        <STextDeadlineValue content={formatedDueDate} />
                    )}
                </SFlexDeadline>
            </SFlexFooter>
        </SFlexEnrollementForm>
    );
};

export default CardProgressFactsheet;

const SFlexEnrollementForm = styled(Flex)`
    background: linear-gradient(
        135deg,
        var(--purple) 0%,
        var(--purple-dark) 100%
    );
    border-radius: 14px;
    padding: 22px 24px;
    position: relative;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(74, 71, 163, 0.22);
    width: 100%;
    ::before {
        content: "";
        position: absolute;
        top: -40px;
        right: -40px;
        width: 160px;
        height: 160px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.06);
    }
    ::after {
        content: "";
        position: absolute;
        bottom: -30px;
        right: 60px;
        width: 90px;
        height: 90px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.04);
    }
`;
const SFlexDeadline = styled(Flex)``;
const STextDeadline = styled(Text)`
    font-size: 11px;
    color: rgba(255, 255, 255, 0.6);
    display: flex;
    align-items: center;
    gap: 4px;
`;
const STextDeadlineValue = styled(Text)`
    font-size: 11px;
    color: rgba(255, 255, 255, 0.6);
    display: flex;
    align-items: center;
    gap: 4px;
    color: rgba(255, 255, 255, 0.88);
    font-weight: bolder;
`;

const SButton = styled(Button)`
    background: white;
    color: var(--purple);
    border: none;
    border-radius: 8px;
    padding: 9px 18px;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    font-family: inherit;
    transition: all 0.15s;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    gap: 6px;
`;

const SFlexProgressLabel = styled(Flex)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
`;
const STextProgress = styled(Text)`
    font-size: 11px;
    color: rgba(255, 255, 255, 0.65);
`;
const STextPercent = styled(Text)`
    font-size: 12px;
    font-weight: 700;
    color: white;
`;

const STextDescription = styled(Text)`
    font-size: 12px;
    color: rgba(255, 255, 255, 0.72);
    line-height: 1.65;
    margin-bottom: 16px;
`;

const SFlexTopIcon = styled(Flex)`
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    flex-shrink: 0;
`;
const STextTitle = styled(Text)`
    font-size: 16px;
    font-weight: 700;
    color: white;
`;

const SFlexTop = styled(Flex)`
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
`;
const SFlexBody = styled(Flex)``;
const SFlexProgress = styled(Flex)`
    margin-bottom: 16px;
`;
const SFlexFooter = styled(Flex)`
    justify-content: space-between;
`;
